import { inject, Injectable, Signal } from '@angular/core';
import { MPKeys } from '@lentau/mpk/shared/constants';
import { IS_B2B } from '@lentau/profile/organizations/legal-entity/shared/tokens/is-b2b-profile.token';
import { environmentBrand } from '@lentau/ui-kit/core/environments/environment.brand';
import { RetailBrands } from '@lentau/ui-kit/core/tokens/constants';

@Injectable({
  providedIn: 'root',
})
export class MpkFactoryService {
  private isB2B: Signal<boolean> = inject(IS_B2B);

  public getMPKByDelivery(isDelivery: boolean): MPKeys {
    switch (environmentBrand.BRAND) {
      case RetailBrands.LENTA_ONLINE:
        return this.getLentaMPK(isDelivery);
      case RetailBrands.DOM:
        return this.getDomMPK(isDelivery);
      case RetailBrands.UTKONOS:
        return MPKeys.UTKONOS_DELIVERY;
      case RetailBrands.MONETKA:
        return MPKeys.MONETKA_B2C_DELIVERY;
      case RetailBrands.SUPERJAM:
        return this.getSuperJamMPK(isDelivery);
      case RetailBrands.REMI:
        return this.getRemiMPK(isDelivery);
      default:
        return MPKeys.LENTA_B2C_PICKUP;
    }
  }

  private getLentaMPK(isDelivery: boolean): MPKeys {
    if (isDelivery) {
      return this.isB2B() ? MPKeys.LENTA_B2B_DELIVERY : MPKeys.LENTA_B2C_DELIVERY;
    }
    return this.isB2B() ? MPKeys.LENTA_B2B_PICKUP : MPKeys.LENTA_B2C_PICKUP;
  }

  private getSuperJamMPK(isDelivery: boolean): MPKeys {
    if (isDelivery) {
      return MPKeys.SUPERJAM_B2C_DELIVERY;
    }
    return MPKeys.SUPERJAM_B2C_PICKUP;
  }

  private getRemiMPK(isDelivery: boolean): MPKeys {
    if (isDelivery) {
      return MPKeys.REMI_B2C_DELIVERY;
    }
    return MPKeys.REMI_B2C_PICKUP;
  }

  private getDomMPK(isDelivery: boolean): MPKeys {
    if (isDelivery) {
      return MPKeys.DOM_B2C_DELIVERY;
    }
    return MPKeys.DOM_B2C_PICKUP;
  }
}
